export enum ShopSelectToolbarButtons {
  GEOLOCATION,
  ZOOM_IN,
  ZOOM_OUT,
}
